import { render, staticRenderFns } from "./ContentFilters.vue?vue&type=template&id=90bc2602"
import script from "./ContentFilters.vue?vue&type=script&lang=js"
export * from "./ContentFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports